import { registerToolCallContextEnricher } from '@erikdakoda/ai-tool/shared/toolCallContextEnrichers';
import { enrichSpawnToolCallContext } from '@erikdakoda/ai-tool/shared/enrichSpawnToolCall';

const SPAWN_TOOL_IDS = ['spawnAgent'] as const;

/** Registers i18n enrichers for spawn tools that expose `jobState` in tool output. */
export function registerSpawnToolCallEnrichers(): void {
  for (const toolId of SPAWN_TOOL_IDS) {
    registerToolCallContextEnricher(toolId, enrichSpawnToolCallContext);
  }
}
